<template>
  <div class="body_right">
    <div class="body_right_first">
      <div class="img"><img src="@/assets/imgs/icon_open.png"></div>
      <div class="title">コメント通知</div>
    </div>
    <div class="body_right_second">
      <div class="body_right_second_scrollbar">
        <comment-notice-item v-for="(item,index) in cacheCommentMsg" :key="index" :data="item" v-if="item"></comment-notice-item>
      </div>
    </div>
  </div>
</template>

<script>
import commentNoticeItem from '@/components/commentNoticeItem/index'
import * as cache from '@/assets/js/cache'
import deepCopy from 'json-deep-copy'
import { isEmptyObject } from '@/assets/js/util'
  export default {
    components: {
      commentNoticeItem
    },
    data () {
      return {
        cacheCommentMsg: []
      }
    },
    created () {
      this.fetch()
    },
    watch:{
      "$store.state.commentMsg":{
        handler:function(newval,oldval){
          this.fetch()
        }
      }
    },
    methods: {
      fetch () {
        const user = this.$store.state.userInfo
        if(this.$store.state.commentMsg){
          this.cacheCommentMsg = this.$store.state.commentMsg[user.id]
        }
        if(this.cacheCommentMsg){
          if (!isEmptyObject(this.cacheCommentMsg)) {
            for (let i = 0; i < this.cacheCommentMsg[user.id].length; i++) {
              this.cacheCommentMsg[user.id][i].read = 1
            }
          }
        }
      },
    }
  }
</script>

<style src="@/pages/homePage/notice/likeNotice/index.css" scoped>
</style>

